const ACCOUNTS_ROUTES = {
  index: '/v1/accounts',
  autocomplete: '/v1/accounts/autocomplete',
  get: '/v1/accounts/:id',
  update: '/v1/accounts/:id',
  create: '/v1/accounts',
  destroy: '/v1/accounts/:id',
  lock: '/v1/accounts/:id/lock',
  activate: '/v1/accounts/:id/activate',
}

const AUTH_ROUTES = {
  login: '/auth/sign_in',
  logout: '/auth/sign_out'
}

const ENTRIES_ROUTES = {
  index: '/v1/reports/:id/entries',
  batch_update: '/v1/reports/:feed_id/entries/batch_update',
  um: '/v1/reports/:id/update_rows',
  add_title_columns: '/v1/reports/:id/add_title_columns',
  add_columns: '/v1/reports/:id/add_column',
  set_counters: '/v1/reports/:id/set_counters',
  remove_column: '/v1/reports/:id/remove_column',
  populate_description: '/v1/reports/:id/populate_description',
  duplicate_row: '/v1/reports/:feed_id/entries/:entry_id/duplicate',
  mark_read: '/v1/reports/:feed_id/entries/:entry_id/mark_read',
  publish_row: '/v1/reports/:feed_id/entries/:entry_id/publish',
  unpublish_row: '/v1/reports/:feed_id/entries/:entry_id/unpublish',
  multiple_mark_read: '/v1/reports/:feed_id/mark_read_entries',
  multiple_publish: '/v1/reports/:feed_id/publish_entries',
  multiple_unpublish: '/v1/reports/:feed_id/unpublish_entries'
}

const REPORTS_ROUTES = {
  index: '/v1/reports',
  get: '/v1/reports/:id',
  export: '/v1/reports/:id/export.xlsx',
  create: '/v1/reports',
  create_optimized: '/v1/reports/:id/create_optimized_report',
  publish: '/v1/reports/:id/publish',
  update_xml: '/v1/reports/:id/update_xml',
  upload_new: '/v1/reports/:id/upload_new',
  unpublish: '/v1/reports/:id/unpublish',
  publish_all: '/v1/reports/:id/publish_all',
  unpublish_all: '/v1/reports/:id/unpublish_all',
  archive: '/v1/reports/:id/archive',
  clone: '/v1/reports/:id/clone',
  restore: '/v1/reports/:id/restore',
  destroy: '/v1/reports/:id',
  archive_index: '/v1/reports/archive'
}

const FEEDS_ROUTES = {
  index: '/v1/reports',
  get: '/v1/reports/:id',
  create: '/v1/reports',
  create_optimized: '/v1/reports/:id/create_optimized_feed',
  publish: '/v1/reports/:id/publish',
  update_xml: '/v1/reports/:id/update_xml',
  upload_new: '/v1/reports/:id/upload_new',
  unpublish: '/v1/reports/:id/unpublish',
  publish_all: '/v1/reports/:id/publish_all',
  unpublish_all: '/v1/reports/:id/unpublish_all',
  archive: '/v1/reports/:id/archive',
  clone: '/v1/reports/:id/clone',
  restore: '/v1/reports/:id/restore',
  destroy: '/v1/reports/:id',
  archive_index: '/v1/reports/archive'
}

const PREFERENCES_ROUTES = {
  index: '/v1/preferences',
  update: '/v1/preferences/:id',
}

const SCRIPTS_ROUTES = {
  index: '/v1/accounts/:account_id/scripts',
  create: '/v1/accounts/:account_id/scripts',
  update: '/v1/accounts/:account_id/scripts/:script_id',
  destroy: '/v1/accounts/:account_id/scripts/:script_id'
}

const USERS_ROUTES = {
  index: '/v1/users',
  get: '/v1/users/:id',
  update: '/v1/users/:id',
  create: '/v1/users',
  destroy: '/v1/users/:id',
  lock: '/v1/users/:id/lock',
  unlock: '/v1/users/:id/unlock',
  change_password: '/v1/users/:id/change_password'
}

export {
  ACCOUNTS_ROUTES,
  AUTH_ROUTES,
  ENTRIES_ROUTES,
  FEEDS_ROUTES, // kill this later
  REPORTS_ROUTES,
  PREFERENCES_ROUTES,
  SCRIPTS_ROUTES,
  USERS_ROUTES
}



// WEBPACK FOOTER //
// ./src/js/constants/routePaths.js